// The URL of /marketing carries three words and a number, never text (CONTRACTS.md section 5): the tab, how the funnel is
// grouped and how many days it looks back. A value that is not one of these is dropped; the defaults are not written.
export const TABS = ['funnel', 'utm', 'weekly'] as const
export type Tab = (typeof TABS)[number]
export const BYS = ['campaign', 'wave', 'channel', 'family', 'owner'] as const
export type By = (typeof BYS)[number]
export const PERIODS = [30, 90, 365] as const
export type Period = (typeof PERIODS)[number]

export const DEFAULT_TAB: Tab = 'funnel'
export const DEFAULT_BY: By = 'wave'
/** The API's own default window (apps/api/src/marketing/funnel.ts DEFAULT_DAYS). */
export const DEFAULT_PERIOD: Period = 90

export interface MarketingSearch {
  tab?: Tab
  by?: By
  days?: Period
}

export function parseSearch(search: Record<string, unknown>): MarketingSearch {
  const tab = TABS.find((x) => x === search.tab)
  const by = BYS.find((x) => x === search.by)
  const days = PERIODS.find((x) => String(x) === String(search.days))
  return {
    ...(tab && tab !== DEFAULT_TAB ? { tab } : {}),
    ...(by && by !== DEFAULT_BY ? { by } : {}),
    ...(days && days !== DEFAULT_PERIOD ? { days } : {}),
  }
}
